export const sum = arr => arr.reduce((a,b)=>a+b,0);
export const pct = (v,t) => t>0?((v/t)*100).toFixed(1):"0.0";
export const fmtMoney=v=>v==null?"—":`$${v.toLocaleString(undefined,{maximumFractionDigits:0})}`;
export const fmtMetric=(v,unit)=>v==null?"—":`${v.toLocaleString(undefined,{maximumFractionDigits:1})} ${unit}`;
